<template>
  <main class="knowledge-page">
    <section class="knowledge-hero">
      <div>
        <span class="eyebrow">短知识 · 真命令 · 可实操</span>
        <h1>运维知识库</h1>
        <p>三分钟理解一个关键知识点，再进入真实 Linux 环境亲手验证。</p>
      </div>
      <div class="hero-stat"><strong>{{ cards.length }}</strong><span>张知识卡片</span></div>
    </section>

    <section class="filters">
      <el-input v-model="query" clearable placeholder="搜索 TCP、负载均衡、MySQL、Kubernetes…" />
      <div class="category-list">
        <el-button v-for="category in categories" :key="category" size="small"
          :type="selectedCategory === category ? 'primary' : 'default'" @click="selectedCategory = category">
          {{ category }}
        </el-button>
      </div>
      <div v-if="isFocused" class="focus-tip">
        <span>今天先读这一张。想找特定内容时，再使用搜索或分类。</span>
        <el-button link type="primary" @click="pickRandomCard">换一张</el-button>
      </div>
    </section>

    <section v-if="filteredCards.length" class="card-grid">
      <article v-for="card in filteredCards" :key="card.slug" class="knowledge-card" @click="openCard(card)">
        <div class="card-meta"><span>{{ card.category }}</span><span>{{ card.level }}</span></div>
        <h2>{{ card.title }}</h2>
        <p>{{ card.summary }}</p>
        <div class="card-footer"><span>约 3 分钟</span><strong>查看知识卡 →</strong></div>
      </article>
    </section>
    <el-empty v-else description="没有找到匹配的知识卡片" />
  </main>
</template>

<script>
import { knowledgeCards, knowledgeCategories } from "../data/knowledgeCards";

export default {
  name: "KnowledgeLibrary",
  data() {
    return { query: "", selectedCategory: "全部", cards: knowledgeCards, categories: knowledgeCategories, randomSlug: "" };
  },
  computed: {
    isFocused() { return !this.query.trim() && this.selectedCategory === "全部"; },
    filteredCards() {
      const query = this.query.trim().toLowerCase();
      const matches = this.cards.filter((card) => {
        const categoryMatches = this.selectedCategory === "全部" || card.category === this.selectedCategory;
        const content = [card.title, card.summary, card.takeaway, card.category, ...card.points].join(" ").toLowerCase();
        return categoryMatches && (!query || content.includes(query));
      });
      if (this.isFocused) return matches.filter((card) => card.slug === this.randomSlug).slice(0, 1);
      return matches;
    },
  },
  created() { this.pickRandomCard(); },
  methods: {
    openCard(card) { this.$router.push(`/knowledge/${card.slug}`); },
    pickRandomCard() {
      const choices = this.cards.filter((card) => card.slug !== this.randomSlug);
      const selected = choices[Math.floor(Math.random() * choices.length)] || this.cards[0];
      this.randomSlug = selected?.slug || "";
    },
  },
};
</script>

<style scoped>
.knowledge-page{max-width:1180px;margin:0 auto;padding:22px 20px 60px;color:#1f2d3d}.knowledge-hero{display:flex;align-items:center;justify-content:space-between;gap:24px;padding:34px 38px;background:linear-gradient(135deg,#f5f9ff,#eef8f4);border:1px solid #dce9e2;border-radius:18px}.eyebrow{color:#16835f;font-size:13px;font-weight:700;letter-spacing:1px}.knowledge-hero h1{margin:8px 0;font-size:36px}.knowledge-hero p{margin:0;color:#5d6b78}.hero-stat{min-width:130px;text-align:center;padding:18px;background:#fff;border:1px solid #dfe8e5;border-radius:14px}.hero-stat strong,.hero-stat span{display:block}.hero-stat strong{color:#16835f;font-size:32px}.filters{margin:22px 0}.filters .el-input{max-width:520px}.category-list{display:flex;flex-wrap:wrap;gap:8px;margin-top:14px}.category-list .el-button{margin:0}.focus-tip{display:flex;align-items:center;justify-content:space-between;max-width:620px;margin-top:14px;padding:10px 14px;color:#607080;background:#f8fafc;border:1px solid #e5eaf0;border-radius:9px;font-size:13px}.card-grid{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:16px}.knowledge-card{display:flex;min-height:210px;flex-direction:column;padding:22px;background:#fff;border:1px solid #e2e8f0;border-radius:14px;cursor:pointer;transition:.2s ease}.knowledge-card:hover{transform:translateY(-3px);border-color:#80c9af;box-shadow:0 10px 28px rgba(27,74,57,.09)}.card-meta{display:flex;gap:8px}.card-meta span{padding:3px 8px;color:#39715f;background:#edf8f3;border-radius:999px;font-size:12px}.knowledge-card h2{margin:16px 0 10px;font-size:19px}.knowledge-card p{margin:0;color:#607080;line-height:1.7}.card-footer{display:flex;justify-content:space-between;margin-top:auto;padding-top:18px;color:#87939e;font-size:13px}.card-footer strong{color:#16835f}@media(max-width:900px){.card-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}@media(max-width:620px){.knowledge-page{padding:12px}.knowledge-hero{align-items:flex-start;padding:24px;flex-direction:column}.knowledge-hero h1{font-size:28px}.hero-stat{display:none}.focus-tip{align-items:flex-start;flex-direction:column}.card-grid{grid-template-columns:1fr}}
</style>
